/**
 * Baby Pokémon: the pre-evolutions Game Freak added in a later generation than
 * the species they evolve into (Pichu arrived two generations after Pikachu).
 * Nineteen species, the same set PokéAPI flags `is_baby` (2026-09-09 owner
 * ask: a "Baby" class in the Dex and trade filters).
 *
 * Hand-curated rather than generated: the set is closed (no baby has been
 * added since Toxel in Gen 8) and a generated file would only add a build step
 * for nineteen numbers. See lib/evolutionFamily for the "base" consequence: a
 * baby's first evolution counts as base too, because trainers met Pikachu
 * long before Pichu and file it as the start of the line.
 */
export const BABY_DEX_NUMBERS: readonly number[] = [
  172, // Pichu      -> Pikachu
  173, // Cleffa     -> Clefairy
  174, // Igglybuff  -> Jigglypuff
  175, // Togepi     -> Togetic
  236, // Tyrogue    -> Hitmonlee / Hitmonchan / Hitmontop
  238, // Smoochum   -> Jynx
  239, // Elekid     -> Electabuzz
  240, // Magby      -> Magmar
  298, // Azurill    -> Marill
  360, // Wynaut     -> Wobbuffet
  406, // Budew      -> Roselia
  433, // Chingling  -> Chimecho
  438, // Bonsly     -> Sudowoodo
  439, // Mime Jr.   -> Mr. Mime
  440, // Happiny    -> Chansey
  446, // Munchlax   -> Snorlax
  447, // Riolu      -> Lucario
  458, // Mantyke    -> Mantine
  848, // Toxel      -> Toxtricity
];

const BABIES = new Set<number>(BABY_DEX_NUMBERS);

export function isBabyDex(dexNumber: number): boolean {
  return BABIES.has(dexNumber);
}
